import { getClient } from "./utilities";

export const LoginLojistas = {
  isLoggedIn: false,
  client: {},
  initialProducts: [...document.querySelectorAll('.product-block-lojista')],
  sectionWaitingAccess: document.querySelector('[data-section="waiting-access"]'),
  sectionLogin: document.querySelector('[data-section="login"]'),
  sectionProducts: document.querySelector('[data-section="products"]'),

  // Seta as informações do cliente
  setClient: async function () {
    const client = await getClient();

    if (Object.keys(client).length > 0) {
      this.isLoggedIn = true;
      this.client = client;
    }

    this.showSectionByClientStatus();
  },

  // Controla qual seção exibir baseado no status do cliente
  showSectionByClientStatus: function () {
    if (this.isLoggedIn) {
      if (this.client.tags && this.client.tags.includes('lojistas')) {
        this.sectionProducts.classList.add('-visible');
        this.updateProductsPrice(this.initialProducts);
      } else {
        this.sectionWaitingAccess.classList.add('-visible');
      }
    } else {
      this.sectionLogin.classList.add('-visible');
    }
  },

  // Busca o preço baseado nas informações do cliente
  fetchPrice: async function (id, sku) {
    let priceURL = `/produto/preco/${id}`;

    if (this.isLoggedIn) {
      priceURL = `/produto/preco/cliente/${id}`;
    }

    const priceConfig = {}
    const response = await fetch(priceURL, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    });

    const data = await response.json();
    data.variants.forEach((variant) => {
      if (sku == variant.sku) {
        priceConfig.price = variant.price;
        priceConfig.sale_price = variant.sale_price;
      }
    })
    priceConfig.available = data.available;

    return priceConfig;
  },

  // Atualiza os produtos com o preço original e o preço remarcado baseado no cliente
  updateProductsPrice: function (products) {
    products.forEach(async function (product) {
      const id = product.getAttribute('data-product-id');
      const sku = product.getAttribute('data-product-sku');
      const priceWrapper = product.querySelector('[data-seller-price]');

      const { price, sale_price } = await LoginLojistas.fetchPrice(id, sku);

      if (price != sale_price) {
        priceWrapper.innerHTML = `
          <ins class="desconto">
            Varejo: <span>${store.formatMoney(price)}</span>
          </ins>
          <ins class="desconto">
            Atacado: <strong>${store.formatMoney(sale_price)}</strong>
          </ins>
        `;
      } else {
        priceWrapper.innerHTML = `
          Atacado: <span>${store.formatMoney(price)}</span>
        `;
      }

      product.setAttribute('data-was-processed', true);
    });
  },

  init() {
    this.setClient();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  LoginLojistas.init();
});
